/* eslint-disable global-require */
import mobileInit from "videojs_mobile";
import tools from "tools";

import "videojs_logo_button";
import "videojs_social_sharing";
import "videojs_info_button";
import "videojs_hotkeys";
import "videojs_errors";
import "videojs_dvrseekbar";
import "videojs_quality_selection";
import "custom_loading_spinner";
import "stats_demo";

// TODO
// import program from "videojs_program";
// import adOverlay from "videojs_ad_overlay";
// import "videojs_ads";
// import radio from "videojs_radio";
// import backgroundVideo from "videojs_background_video";

export default function initPlugins(plugins, vjs, browsers, options) {
  const reload = (plgns = {}) => {
    tools.cleanPlugins(plgns);

    /**
     * {
     *  plugin_a: whatever,
     *  videojs_plugin_b:whatever,
     * } =>
     * pluginA(plugin_a);
     * vjs.pluginB(videojs_plugin_b);
     *
     */
    Object.keys(plgns)
      .map(plugin => ({
        options: plugin,
        pluginName: plugin
          .replace("videojs_", "")
          .split("_")
          .reduce(
            (plgn, part) =>
              (plgn += part.charAt(0).toUpperCase() + part.substr(1)),
          ),
      }))
      .forEach(plugin => {
        try {
          if (plugin.options.match(/^videojs_/)) {
            vjs[plugin.pluginName](plgns[plugin.options]);
          } else {
            [plugin.pluginName](plgns[plugin.options]);
          }
        } catch (error) {
          // console.log(error);
        }
      });

    if (plgns.audio_only)
      tools.addCSS(
        "audioOnly",
        `.vjs-control-bar{opacity:1} .vjs-poster{display:block}`,
      );

    if (plgns.audio_only_bar)
      tools.addCSS(
        "audioOnly",
        `.vjs-control-bar{opacity:1} .video-js{height:22px} .vjs-poster{display:none}`,
      );
  };

  reload(plugins);
  mobileInit(vjs, options.playerID, plugins.videojs_radio);
}

module.exports = initPlugins;



// WEBPACK FOOTER //
// ./src/js/loadPlugins.js